import { render, staticRenderFns } from "./UploadMultipleOpportunity.vue?vue&type=template&id=4540f820&scoped=true&"
import script from "./UploadMultipleOpportunity.vue?vue&type=script&lang=js&"
export * from "./UploadMultipleOpportunity.vue?vue&type=script&lang=js&"
import style0 from "./UploadMultipleOpportunity.vue?vue&type=style&index=0&id=4540f820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4540f820",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
